<template>
  <motlet :options="motletOptions">
    <template v-slot:content>
      <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers"
          :items="items"
          :height="params.height"
          single-select
          hide-default-header
          disable-pagination
          dense
          hide-default-footer>
      </v-data-table>
    </template>
  </motlet>
</template>

<script>
import bus from '../../../../../utils/bus';

export default {
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      motletOptions: {
        id: 'detailview/java/javaLog/logSummary',
        title: 'Summary',
      },
      loading: false,
      headers: [
        { value: 'text', text: 'text', align: 'start', sortable: false },
        { value: 'value', text: 'value', align: 'start', sortable: false },
      ],
      pivot: [
        { value: 'seve', text: 'Severity' },
        { value: 'sapYmdhms', text: 'Date', converter: ['format', 'yyyy-MM-dd HH:mm:ss'] },
        { value: 'cate', text: 'Category' },
        { value: 'location', text: 'Location' },
        { value: 'appl', text: 'Application' },
        { value: 'thrdNm', text: 'Thread' },
        { value: 'srcNm', text: 'Data Source' },
        { value: 'dsrRootCtxId', text: 'Passport User Activity ID' },
        { value: 'msgCd', text: 'Message ID' },
        { value: 'sssn', text: 'Session' },
        { value: 'trxn', text: 'Transaction' },
        { value: 'usrNm', text: 'User' },
        { value: 'csnComp', text: 'Customer message Component' },
        { value: 'dcNm', text: 'Runtime Component' },
        { value: 'corrId', text: 'Correlation ID' },
        { value: 'dsrTrxn', text: 'Passport Session' },
        { value: 'dsrConn', text: 'Passport Connection' },
        { value: 'dsrCnt', text: 'Passport Connection Counter' },
        { value: 'logId', text: 'Log ID' },
      ],
      items: [],
    };
  },
  methods: {
    fetch(data) {
      this.items = data ? this.pivot.map(p => ({ text: p.text, value: this.converter(data[p.value], p.converter) })) : [];
    },
    converter(value, name) {
      const converter = {
        name,
        argument: undefined,
      };
      if (Array.isArray(name)) {
        converter.name = name[0];
        converter.argument = name[1];
      }
      return converter.name ? (this.$options.filters[converter.name] ? this.$options.filters[converter.name](value, converter.argument) : value) : value;
    },
  },
  created() {
    bus.$on('select:log', this.fetch);
  },
  destroyed() {
    bus.$off('select:log');
  },
};
</script>
